import { MouseEventHandler, useContext, useEffect } from 'react';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import { AppContext } from 'providers/AppProvider';
import { Button } from '@arionbanki/arionui';
import { getMode } from 'helpers';

const STICKY_FOOTER_CLASSNAME = 'sticky-footer-container';

type FooterProps = Readonly<{
	className?: string;
	handleNext?: MouseEventHandler;
	handlePrev?: MouseEventHandler;
	isDisabled?: boolean;
	mode?: 'stroked' | 'blue' | 'primary' | 'secondary' | 'success' | 'warning' | 'error';
	next?: string;
	prev?: string;
}>;

export function Footer(props: FooterProps) {
	return (
		<>
			<FooterInner {...props} />
			<StickyFooter {...props} />
		</>
	);
}

function FooterInner(props: FooterProps) {
	const { className, handleNext, handlePrev, isDisabled, next, prev } = props;

	const prevButton = prev && handlePrev && (
		<Button onClick={handlePrev} size="large" mode="stroked">
			{prev}
		</Button>
	);

	const nextButton = next && handleNext && (
		<Button disabled={isDisabled} onClick={handleNext} size="large" mode={props.mode}>
			{next}
		</Button>
	);

	const prevCN = cx({ 'col-6': prevButton, 'd-none': !prevButton });
	const nextCN = cx('text-right', { 'col-6': prevButton, 'col-12': !prevButton });

	return (
		<footer className={cx('footer py-4 mt-5', className)}>
			<div className="container">
				<div className="row">
					<div className="col-12">
						<div className="row">
							{prevButton && <div className={prevCN}>{prevButton}</div>}
							{nextButton && <div className={nextCN}>{nextButton}</div>}
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}

function StickyFooter(props: FooterProps) {
	const { flowType } = useContext(AppContext);
	const className = cx(`sticky-footer theme--${getMode(flowType)}`, props.className);
	const hasClassName = document.body.classList.contains(STICKY_FOOTER_CLASSNAME);

	useEffect(() => {
		document.body.classList.add(STICKY_FOOTER_CLASSNAME);
		return () => {
			document.body.classList.remove(STICKY_FOOTER_CLASSNAME);
		};
	}, [hasClassName]);

	return ReactDOM.createPortal(<FooterInner {...props} className={className} />, document.body);
}
